@if (featureSet) {
  <div class="device-container flex-even mx-2" matTooltip="{{featureSet.name}}" (click)="clicked()">
    <div class="icon-container">
      <i class="icon" class="{{ icons.getIcon(iconProductCode) }}"></i>
    </div>
    <div class="title-text">
      {{featureSet.displayName}}
    </div>
  </div>
}
